import { readPersistedSessionIds } from './kronosPrefs/sessionIds';
import {
    emptyUserInstancePrefs,
    mergeUserInstancePrefsPatch,
    readUserInstancePrefsDoc,
} from './kronosPrefs/userInstancePrefs';

/** @deprecated One-shot migration from pre-scoped storage */
const LEGACY_FLAT_STORAGE_KEY = 'kronos.selectedEditionId';

/**
 * Read selected edition from user↔instance prefs (localStorage).
 * Kept outside the Redux editionNavigation module so Client can scope
 * API calls without a circular import graph.
 *
 * @returns {string|null}
 */
export function readPersistedEditionId() {
    try {
        const { userId, instanceId } = readPersistedSessionIds();
        if (!userId) {
            return null;
        }
        const inst = instanceId != null && instanceId !== '' ? String(instanceId) : 'none';
        const doc = readUserInstancePrefsDoc(userId, inst) || emptyUserInstancePrefs();
        const blob = doc.editionNavigation;
        const id = blob && typeof blob === 'object' ? blob.selectedEditionId : null;
        if (id != null && id !== '') {
            return String(id);
        }
        if (typeof window !== 'undefined' && window.localStorage) {
            const legacy = window.localStorage.getItem(LEGACY_FLAT_STORAGE_KEY);
            if (legacy) {
                mergeUserInstancePrefsPatch(userId, inst, {
                    editionNavigation: { selectedEditionId: String(legacy) },
                });
                window.localStorage.removeItem(LEGACY_FLAT_STORAGE_KEY);
                return String(legacy);
            }
        }
        return null;
    } catch (_e) {
        return null;
    }
}

/**
 * @param {string|null|undefined} editionId
 * @returns {void}
 */
export function persistEditionId(editionId) {
    try {
        const { userId, instanceId } = readPersistedSessionIds();
        if (!userId) {
            return;
        }
        if (!editionId) {
            mergeUserInstancePrefsPatch(userId, instanceId, {
                editionNavigation: { selectedEditionId: null },
            });
        } else {
            mergeUserInstancePrefsPatch(userId, instanceId, {
                editionNavigation: { selectedEditionId: String(editionId) },
            });
        }
        if (typeof window !== 'undefined' && window.localStorage) {
            window.localStorage.removeItem(LEGACY_FLAT_STORAGE_KEY);
        }
    } catch (_e) {
        /* ignore storage failures (private mode, etc.) */
    }
}

/**
 * @param {string|null|undefined} userId
 * @param {string|null|undefined} instanceId
 * @returns {string|null}
 */
export function readPersistedEditionIdForUserInstance(userId, instanceId) {
    try {
        if (!userId) {
            return null;
        }
        const inst = instanceId != null && instanceId !== '' ? String(instanceId) : 'none';
        const doc = readUserInstancePrefsDoc(userId, inst) || emptyUserInstancePrefs();
        const blob = doc.editionNavigation;
        const id = blob && typeof blob === 'object' ? blob.selectedEditionId : null;
        if (id != null && id !== '') {
            return String(id);
        }
        if (typeof window !== 'undefined' && window.localStorage) {
            const legacy = window.localStorage.getItem(LEGACY_FLAT_STORAGE_KEY);
            if (legacy) {
                mergeUserInstancePrefsPatch(userId, inst, {
                    editionNavigation: { selectedEditionId: String(legacy) },
                });
                window.localStorage.removeItem(LEGACY_FLAT_STORAGE_KEY);
                return String(legacy);
            }
        }
        return null;
    } catch (_e) {
        return null;
    }
}
